// Need to be defined in separate file to avoid circular dependency
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const USER_SWITCHED_ACCOUNT = "USER_SWITCHED_ACCOUNT";
